// src/pages/categories/components/CategoryItem/CategoryItem.tsx

import React from 'react';
import { Link } from 'react-router-dom';
import { CategoryInterface } from '../../../../common/types/types';
import { getImageUri } from '../../../../common/utils/functions/getImageUri';
import { shortenText } from '../../../../common/utils/functions/shortenText';
import styles from './CategoryItem.module.scss';

type Props = {
  category: CategoryInterface;
};

export default function CategoryItem({ category }: Props) {
  return (
    <Link 
      to={`/category/${category.id}`} 
      className={styles.container}
      aria-label={`Перейти в категорию ${category.name}`}
    >
      {category.files?.[0] ? (
        <img
          src={`${getImageUri()}${category.files[0]}`}
          alt={category.name}
          className={styles.image}
        />
      ) : (
        <div className={styles.imagePlaceholder}>
          <span className={styles.placeholderText}>Нет фото</span>
        </div>
      )}
      
      <div className={styles.contentBlock}>
        <span className={styles.name}>{category.name}</span>
        {category.description && (
          <p className={styles.description}>
            {shortenText(category.description, 120)}
          </p>
        )}
      </div>
    </Link>
  );
}